export const ACTIONS = {
  SET_FILE: 'SET_FILE',
  SET_ACTIVE_STEP: 'SET_ACTIVE_STEP',
  SET_VALIDATION_STATUS: 'SET_VALIDATION_STATUS',
  SET_VALIDATION_RESULTS: 'SET_VALIDATION_RESULTS',
  SET_PROCESSING_STATUS: 'SET_PROCESSING_STATUS',
  UPDATE_PROGRESS: 'UPDATE_PROGRESS',
  SET_RESULTS: 'SET_RESULTS',
  SET_ERROR: 'SET_ERROR',
  RESET: 'RESET',
  RESET_VALIDATION: 'RESET_VALIDATION', 
};

export const setFile = (file) => ({
  type: ACTIONS.SET_FILE,
  payload: file,
});

export const setActiveStep = (step) => ({
  type: ACTIONS.SET_ACTIVE_STEP,
  payload: step,
});

export const setValidationStatus = (status) => ({
  type: ACTIONS.SET_VALIDATION_STATUS,
  payload: status,
});

export const setValidationResults = (results) => ({
  type: ACTIONS.SET_VALIDATION_RESULTS,
  payload: results,
});

export const setProcessingStatus = (status) => ({
  type: ACTIONS.SET_PROCESSING_STATUS,
  payload: status,
});

export const updateProgress = (progress) => ({
  type: ACTIONS.UPDATE_PROGRESS,
  payload: progress,
});

export const setResults = (results) => ({
  type: ACTIONS.SET_RESULTS,
  payload: results,
});

export const setError = (error) => ({
  type: ACTIONS.SET_ERROR,
  payload: error,
});

export const reset = () => ({
  type: ACTIONS.RESET,
});

export const resetValidation = () => ({
  type: ACTIONS.RESET_VALIDATION,
});